<template>
  <router-link
    v-if="!item.action"
    :to="getLink(item.to, item.query)"
    :class="[linkClass, isActive ? 'active' : '']"
  >
    <icon v-if="item.icon" :type="item.icon" class="mr-1" />
    <img
      v-if="item.image"
      :src="item.image.src"
      :width="item.image.width"
      :height="item.image.height"
      class="mr-1"
    />
    {{ item.label }}
    <span v-if="item.badgeKey" class="badge badge-pill badge-danger ml-1">
      <span v-if="showBadge" :title="badgeTitle">{{ badgeText }}</span>
    </span>
  </router-link>

  <a
    v-else
    href="/"
    :class="[linkClass, 'calendar-item-link']"
    @click="onActionClick"
  >
    <icon v-if="item.icon" :type="item.icon" class="mr-1" />
    <img
      v-if="item.image"
      :src="item.image.src"
      :width="item.image.width"
      :height="item.image.height"
      class="mr-1"
    />
    {{ item.label }}
    <span v-if="item.badgeKey" class="badge badge-pill badge-danger ml-1">
      <span v-if="showBadge" :title="badgeTitle">{{ badgeText }}</span>
    </span>
  </a>
</template>
<script>
import { isProfileNavItemActive } from "./profileNavResolver";

export default {
  name: "ProfileNavItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    getLink: {
      type: Function,
      required: true,
    },
    linkClass: {
      type: String,
      required: true,
    },
    badges: {
      type: Object,
      default: () => ({}),
    },
    routeName: {
      type: String,
      default: "",
    },
  },
  emits: ["action"],
  computed: {
    isActive() {
      return isProfileNavItemActive(this.item, this.routeName);
    },
    badge() {
      return this.badges[this.item.badgeKey];
    },
    showBadge() {
      return !!(this.badge && !this.badge.loading && this.badge.value);
    },
    badgeText() {
      return this.badge.value > 9 ? "9+" : this.badge.value;
    },
    badgeTitle() {
      return this.badge.title;
    },
  },
  methods: {
    onActionClick(event) {
      event.preventDefault();
      this.$emit("action", this.item.key);
    },
  },
};
</script>
